import axios from 'axios';
import React, { useState } from 'react';
import { Container, TextField, Button, Box, Typography, Paper, Snackbar, Alert, Input } from '@mui/material';
import { API_URL, authHeaders } from '../api';

const PlayerManagement = () => {
    const [playerName, setPlayerName] = useState('');
    const [age, setAge] = useState('');
    const [biography, setBiography] = useState('');
    const [position, setPosition] = useState('');
    const [jerseyNumber, setJerseyNumber] = useState('');
    const [photo, setPhoto] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleSnackbarOpen = () => {
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handlePhotoChange = (event) => {
        setPhoto(event.target.files[0]);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const playerData = new FormData();
        playerData.append('playerName', playerName);
        playerData.append('age', age);
        playerData.append('biography', biography);
        playerData.append('position', position);
        playerData.append('jerseyNumber', jerseyNumber);
        playerData.append('photo', photo);

        try {
            const response = await axios.post(`${API_URL}/api/players`, playerData, {
                headers: {
                    ...authHeaders(),
                },
            });
            console.log('Player added successfully:', response.data);
            handleSnackbarOpen(); // Open the snackbar on success
            // Clear the form fields
            setPlayerName('');
            setAge('');
            setBiography('');
            setPosition('');
            setJerseyNumber('');
            setPhoto(null);
        } catch (error) {
            console.error('Error adding player:', error);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} style={{ padding: '20px', marginTop: '20px', background: 'transparent' }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Add a New Player
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Box display="flex" flexDirection="column" gap="20px">
                        <TextField 
                            label="Player Name"
                            variant="outlined"
                            value={playerName}
                            onChange={(e) => setPlayerName(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Age"
                            type="number"
                            variant="outlined"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Biography"
                            variant="outlined"
                            multiline
                            rows={4}
                            value={biography}
                            onChange={(e) => setBiography(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Playing Position"
                            variant="outlined"
                            value={position}
                            onChange={(e) => setPosition(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Jersey Number"
                            type="number"
                            variant="outlined"
                            value={jerseyNumber}
                            onChange={(e) => setJerseyNumber(e.target.value)}
                            required
                        />
                        <Input 
                            type="file"
                            onChange={handlePhotoChange}
                            required
                        />
                        <Button type="submit" variant="contained" color="primary" sx={{ padding: '10px' }}>
                            Add Player
                        </Button>
                    </Box>
                </form>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                    <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                        Player added successfully!
                    </Alert>
                </Snackbar>
            </Paper>
        </Container>
    );
};

export default PlayerManagement;
